import { render, staticRenderFns } from "./fail.vue?vue&type=template&id=8ac8c21c&scoped=true&lang=pug&"
import script from "./fail.vue?vue&type=script&lang=js&"
export * from "./fail.vue?vue&type=script&lang=js&"
import style0 from "./fail.vue?vue&type=style&index=0&id=8ac8c21c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac8c21c",
  null
  
)

export default component.exports